<div class="mwp-modal">
    <div class="header">
        <mwp-text-translate text="Total Summary" jsonKey="totalSummary" />
    </div>
    <div class="body pb-2">
        <mwp-deduction-summary [memberBenefitFlyout]="memberBenefitFlyout" />
    </div>
    <div class="footer d-inline-flex w-100 justify-content-center">
        <button class="mwp-button-secondary" (click)="closeDialog()">
            <mwp-text-translate text="Close" jsonKey="close" />
        </button>
    </div>
</div>